/*
 * src/components/MessageCenter/StandardView.jsx
 * Description: Browser view w/ Paymints Table
 * Copyright (c) 2020 PredictiveUX
 */
import React from "react";

import PaymintsTable from "../PaymintsTable/PaymintsTable";

import columnCfg from "./MessageCenterColumnCfg";
import "./messageCenter.css";

const StandardView = ({ tableData, pdfOpenHandler }) => {
  /**
   * The "antD" <Table> component requires a "key" property for each record.
   * @param {*} tableData
   * @returns
   */
  const addKeyToTableData = (tableData) => {
    return tableData.map((m) => {
      return {
        ...m,
        key: m.id,
      };
    });
  };

  return (
    <div className="message__table-container">
      <PaymintsTable
        columns={columnCfg(pdfOpenHandler)}
        dataSource={addKeyToTableData(tableData)}
        pagination={{ position: "both" }}
      />
    </div>
  );
};

export default StandardView;
